<div fxLayout="column" fxLayoutAlign="center center" class="spinner">
  <mat-spinner [diameter]="36" color="primary"></mat-spinner>
</div>
